import React from 'react'
import { Modal, ModalProps } from 'antd'
import styles from './index.less'
import { getIsFreeVersionPreCharge, ModalContentType, PrePayNoticeCode } from '../noticeType'
import { onGoAllOrder } from '@/modules/order/helper'

const bgUrlFree = 'https://assets.sursung.com/activity/20250225/9482D980CCE94F8187C889E696A4B1601740448565906.png'
const bgUrlFindCooper = 'https://assets.sursung.com/activity/20250507/2B41D8D01D3A4FDE90CB163080B46AA31746602591774.png'

export const Content = (props: ModalContentType & ModalProps) => {
    const { onOk, code } = props

    if (code === PrePayNoticeCode.RISK_MIDDLE_COMPANY) {
        return (
            <div className={styles.bg}>
                <div
                    style={{
                        color: '#1D2129',
                        fontSize: '24px',
                        fontWeight: 600,
                        lineHeight: '18px',
                        marginTop: '45px',
                        textAlign: 'center'
                    }}
                >
                    暂不支持充值/授信
                </div>

                <div
                    style={{
                        color: '#1D2129',
                        fontSize: '14px',
                        fontWeight: 400,
                        marginTop: '44px',
                        textAlign: 'center'
                    }}
                >
                    为保证您的订单正常履约及资金安全，促进生意长久合作
                </div>

                <div
                    style={{
                        height: '100px',
                        padding: '1px 25px',
                        textAlign: 'center',
                        backgroundColor: '#FFFAF3',
                        borderRadius: '8px',
                        marginTop: '19px'
                    }}
                >
                    <div
                        style={{
                            color: '#1D2129',
                            fontSize: '16px',
                            fontWeight: 600,
                            marginTop: '24px'
                        }}
                    >
                        分销商推单需
                        <span style={{ color: '#00B42A' }}>在线支付</span>
                    </div>
                    <div
                        style={{
                            color: '#1D2129',
                            fontSize: '16px',
                            fontWeight: 400,
                            marginTop: '7px'
                        }}
                    >
                        资金流转更安全
                    </div>
                </div>
                <div style={{ height: '20px' }} />
                <div className={styles.footer}>
                    <a className={styles.cancelbtn} onClick={onOk}>
                        我知道了
                    </a>
                </div>
            </div>
        )
    }

    const isFree = getIsFreeVersionPreCharge(code)
    const url = isFree ? bgUrlFree : bgUrlFindCooper

    return (
        <div className={styles.container}>
            <div
                style={{
                    backgroundImage: `url(${url})`
                }}
                className={styles.content}
            />
            <div className={styles.footer}>
                <a className={styles.cancelbtn} onClick={onOk}>
                    我知道了
                </a>
                <a
                    className={styles.btn}
                    onClick={() => {
                        onGoAllOrder({
                            type: 'open'
                        })
                        onOk()
                    }}
                >
                    去推单支付
                </a>
            </div>
        </div>
    )
}

export default (props: ModalContentType & ModalProps) => {
    return (
        <Modal
            {...props}
            footer={false}
            width={720}
            closable={false}
            title={false}
            bodyStyle={{ padding: 0 }}
            keyboard={false}
            maskClosable={false}
            className={styles.modal}
        >
            <Content code={props.code} onOk={props.onOk} />
        </Modal>
    )
}
